module.exports = __webpack_public_path__ + "static/img/5.6c61b97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/5.png
// module id = HCEE
// module chunks = 0